<DataGridView DataUrl="/Backend/Api/V2/Admin/PushSubscription/List" #Grid KeyProperty="id">
  <DataGridViewColumn field="name" header="Name" />
  <DataGridViewColumn field="url" header="Url" />
  <DataGridViewColumn field="IsActive" header="Aktiv" >
    <ng-template #cell let-row>
      <input type="checkbox" class="form-check-input" [checked]="row.isActive" disabled>
    </ng-template>
  </DataGridViewColumn>
  <DataGridViewColumn [isFixed]="true"  [AllowOrder]="false" [AllowSearch]="false">
    <ng-template #cell let-row>
      <div class="btn btn-sm btn-primary me-1" (click)="EditPartner(row.id)"><i class="fa-solid fa-list-check"></i></div>
      <div class="btn btn-sm btn-primary me-1" (click)="EditAuth(row)"><i class="fa-solid fa-lock"></i></div>
      <div class="btn btn-sm btn-primary me-1" (click)="toggleOnOf(row.id)"><i class="fa-solid fa-toggle-{{row.isActive ? 'on' : 'off'}}"></i></div>
    </ng-template>
    <ng-template #header>
      <div class="btn btn-sm btn-success " (click)="AddNew()"><i class="bi bi-plus"></i></div>
    </ng-template>
  </DataGridViewColumn>
</DataGridView>
